import "./App.css";
import { Route, Routes } from "react-router";
import { BrowserRouter } from "react-router-dom";
import { useEffect, useState } from "react";
import HomePage from "./pages/HomePage";
import packageJson from "../package.json";

function App() {
  //Re-render values of height and width values everytime the window is resized
  console.log(`Version : v${packageJson.version}`);
  console.log("%cDesigned and developed by", "color: #0F8BD1; font-size: 20px");
  console.log(
    "%c⏻aks %cSolution and Studio ",
    "color: #42E501; font-size: 24px; font-weight: 900",
    "color: #0F8BD1; font-size: 24px; font-weight: 900"
  );
  console.log(
    "%cContact us via: 📬 %cinquiry@the-oaks.my",
    "color: #04CFFF; font-size: 14px",
    "color: #0F8BD1; font-size: 16px; font-weight: 700"
  );
  console.log("------------------");
  console.log("%cCredit:", "color: #42E501; font-size: 18px; font-weight: 700");
  console.log(
    "%cChan %ckarhoong@the-oaks.my",
    "color: #04CFFF; font-size: 14px;",
    "color: #FF8BD1; font-size: 16px; font-weight: 700"
  );
  console.log(
    "%cCheng Wei Liang %cwilliam@the-oaks.my",
    "color: #04CFFF; font-size: 14px;",
    "color: #FF8BD1; font-size: 16px; font-weight: 700"
  );
  console.log(
    "%cTee %ckhangjie@the-oaks.my",
    "color: #04CFFF; font-size: 14px;",
    "color: #FF8BD1; font-size: 16px; font-weight: 700"
  );
  console.log(
    "%cPhyllis%c",
    "color: #04CFFF; font-size: 14px;",
    "color: #FF8BD1; font-size: 16px; font-weight: 700"
  );

  const [maxSize, setMaxSize] = useState({
    currentWidth: 0,
    currentHeight: 0,
  });

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const handleResize = () => {
    setMaxSize({
      currentHeight: window.innerHeight,
      currentWidth: window.innerWidth,
    });
    // console.log(maxSize);
  };

  return (
    // Routing
    <div>
      <BrowserRouter basename="/app/map">
        <Routes>
          <Route path="/" element={<HomePage size={maxSize} />} />
        </Routes>
      </BrowserRouter>
      <div className="version">v{packageJson.version}</div>
    </div>
  );
}

export default App;
